import Vue from 'vue'
import VueRouter from 'vue-router'

const Blank = () =>
    import('../components/blank.vue')
const Login = () =>
    import('../components/login/login.vue') // 登录组件
const Home = () =>
    import('../components/home.vue') // home组件
const Index = () =>
    import('../components/index/indexNew.vue') // 首页组件
const Notice = () =>
    import('../components/notice/notice.vue') // 通知中心组件
const NoticeSetting = () =>
    import('../components/notice/settings/noticeSetting.vue') // 通知中心组件
const Evaluate = () =>
    import('../components/evaluate/evaluate.vue') // 评价管理组件
const Fault = () =>
    import('../components/fault/fault.vue') // 问题反馈组件
const Complaint = () =>
    import('../components/evaluate/complaint.vue') //微信消费者投诉组件
const UserData = () =>
    import('../components/data/userData.vue') // 用户数据组件

const Hairfiles = () =>
    import('../components/data/hairfilesNew.vue') // 发型师档案组件
const hairfilesdetail = () =>
    import('../components/data/hairfilesdetailNew.vue') // 发型师档案组件

const Hair = () =>
    import('../components/data/hair.vue') // 发型师数据组件
const GoodsData = () =>
    import('../components/data/goodsData.vue') // 商品数据组件
const StoreData = () =>
    import('../components/data/storeData/storeData.vue') // 门店数据组件
const StoreFileDetail = () =>
    import('../components/data/storeData/storeFileDetail.vue')
const DataLive = () =>
    import('../components/data/dataLive.vue') // 数据实况组件
const StoreList = () =>
    import('../components/store/storeList.vue') // 门店列表组件
const StoreDetail = () =>
    import('../components/store/storeDetail.vue') // 门店详情页组件
const StoreDetail2 = () =>
    import('../components/store/storeDetail/storeDetail2.vue') //新建门店，查看详情
const Join = () =>
    import('../components/store/Join/join.vue') //加盟管理页
const Join1 = () =>
    import('../components/store/Join/join1.vue') //加盟管理1
const Material01 = () =>
    import('../components/material/material01.vue')
const Material = () =>
    import('../components/material/material.vue') //物资列表
const EatTime = () =>
    import('../components/store/eatTime.vue') // 就餐时间
const storeMaterial = () =>
    import('../components/material/storeMaterial.vue')
const NewJoin = () =>
    import('../components/store/newJoin.vue') // 新加盟门商信息组件
const NewJoinnext = () =>
    import('../components/store/newJoin_next.vue') // 新加盟门商信息组件_下一步
const TypeSetting = () =>
    import('../components/store/typeSetting.vue') // 排版管理组件
const AdminList = () =>
    import('../components/user/adminList.vue') // 管理员列表组件
const User_Data = () =>
    import('../components/user/userdata.vue') // 用户数据组件
const companyUser = () =>
    import('../components/user/companyUser.vue') // 用户数据组件
const Udata_Lists = () =>
    import('../components/user/udatalists.vue') // 用户数据组件
const Operaplan = () =>
    import('../components/user/operaplan.vue') // 用户运营
const Newopera = () =>
    import('../components/user/newopera.vue') // 用户运营-新建运营
const Addlabel = () =>
    import('../components/user/addlabel.vue') // 用户运营-新建运营
const Setpeoples = () =>
    import('../components/user/setpeoples.vue') // 用户运营-新建运营
const Volumeset = () =>
    import('../components/marketing/volumeset.vue') // 营销管理-卷设置

const Cost = () => //成本核算
    import('../components/data/cost.vue')
const WorkerCostCount = () => //发型师成本统计
    import('../components/data/workerCostCount.vue')
const CostDetail = () => //成本核算详情
    import('../components/data/costDetail.vue')
const attendance = () =>
    import('../components/attendance/attendance.vue')//考勤中心
const attendance1 = () =>
    import('../components/attendance/attendance/attendance1.vue')//月度统计
const attendance2 = () =>
    import('../components/attendance/attendance/attendance2.vue')//每日考勤
const attendance3 = () =>
    import('../components/attendance/attendance/attendance3.vue')//请假申请
const product_user = () =>
    import('../components/product/product_user.vue') // 产品管理-会员管理
const product_set = () =>
    import('../components/product/product_set.vue') // 会员管理-会员设置
const product_hair = () =>
    import('../components/product/product_hair.vue') // 产品管理-剪发服务
const timeCard = () =>
    import('../components/product/timesCard/list.vue') // 产品管理-次卡管理
const timeCardDetail = () =>
    import('../components/product/timesCard/detail.vue') // 产品管理-次卡详情
const add_hair = () =>
    import('../components/product/product_hair/add_hair.vue') // 产品管理-新建
const product_hair3 = () =>
    import('../components/product/product_hair/product_hair3.vue') // 新建计划

const productCCard = () =>
    import('../components/product/ccard/list.vue') // 产品管理-卡金
const addCCard = () =>
    import('../components/product/ccard/add.vue') // 产品管理-新增卡金
const productUVip = () =>
    import('../components/product/uvip/list.vue') // 产品管理-UVIP
const addUVip = () =>
    import('../components/product/uvip/add.vue') // 产品管理-UVIP

const productGroup = () =>
    import('../components/product/combine/list.vue') //产品管理-套餐管理
const productGroupDetail = () =>
    import('../components/product/combine/detail.vue') //产品管理-套餐详情
// 系统设置
const journal = () =>
    import('../components/system/journal.vue') // 系统设置-操作日志
const jurisdiction = () =>
    import('../components/system/jurisdiction.vue') // 系统设置-权限设置
const employedetails = () =>
    import('../components/system/employedetails.vue') // 系统设置-员工详情
const creatingroles = () =>
    import('../components/system/creatingroles.vue') // 系统设置-创建角色
const addroles = () =>
    import('../components/system/addroles.vue') // 系统设置-创建角色
// 发型师管理
const hairdetail = () => import('../components/hair/hairdetail.vue') // 发型师管理
const achievement = () => import('../components/hair/achievement.vue') // 发型师业绩
const yeji = () => import('../components/hair/achievement/workerYeJi.vue') // 发型师业绩
const hairlist = () => import('../components/hair/hairlist.vue') // 发型师业绩
const covid = () => import('../components/hair/covid_upload.vue') //疫情申报
const changeStore = () => import('../components/hair/changeStore.vue') // 定时调店
const workerDiscount = () => import('../components/hair/workerDiscount.vue') // 熟客抵扣
const WorkerFileDetail = () =>
    import('../components/hair/achievement/workerFileDetail.vue') // 发型师档案详情组件

// ----------------------------------------------
//营销管理
const Volumeseteffort = () => import('../components/marketing/volumeseteffort.vue') // 营销管理-新建卷
const Newvolumeset = () => import('../components/marketing/newvolumeset.vue') // 营销管理-卷-效果数据
const Review = () => import('../components/marketing/review.vue')
const MeituanConfig = () => import('../components/marketing/meituan.vue')

//添加
const Advertisement = () => import('../components/marketing/PopUpAdvertisement/advertisement.vue') // 营销管理-弹窗广告
const MarketingAd = () => import('../components/marketing/PopUpAdvertisement/ad.vue') // 营销管理-弹窗广告
const NewAD = () => import('../components/marketing/PopUpAdvertisement/newAD.vue') // 营销管理-弹窗广告-新建弹窗
const ExchangeCode = () => import('../components/marketing/exchangeCode/exchangeCode.vue') // 营销管理-兑换码
const NewExchangeCode = () => import('../components/marketing/exchangeCode/newExchangeCode.vue') // 营销管理-兑换码-新建兑换码
const Exhistory = () => import('../components/marketing/exchangeCode/Exhistory.vue') // 营销管理-兑换码-使用记录
const HelpActive = () => import('../components/marketing/helpActive/helpActive.vue') // 营销管理-助力活动
const NewHelpActive = () => import('../components/marketing/helpActive/newHelpActive.vue') // 营销管理-助力活动-新建助力
const HelpDetails = () => import('../components/marketing/helpActive/helpDetails.vue') // 营销管理-助力活动-助力详情
const Coupons = () => import('../components/marketing/Coupons/coupons.vue') // 营销管理-券包设置
const NewCoupons = () => import('../components/marketing/Coupons/newCoupons.vue') // 营销管理-券包设置-新建优惠券包
const Poster = () => import('../components/distribution/poster/poster.vue') // 营销管理-裂变海报
const NewPoster = () => import('../components/distribution/poster/newPoster.vue') // 营销管理-裂变海报-新建裂变海报
const MakeUpAGroup = () => import('../components/marketing/MakeUpAGroup/MakeUpAGroup.vue') // 营销管理-拼团管理
const NewMakeUpAGroup = () => import('../components/marketing/MakeUpAGroup/newMakeUpAGroup.vue') // 营销管理-拼团管理-创建拼团
const AppletSettings = () => import('../components/marketing/AppletSettings/AppletSettings.vue') // 营销管理-小程序设置
const memberDetailSetting = () => import('../components/marketing/AppletSettings/memberDetailSetting.vue') //营销管理-会员权益设置
const marketingShare = () => import('../components/marketing/share/marketingShare.vue') //营销管理-裂变
const DmarketingShare = () => import('../components/marketing/share/marketingShareDetail.vue') //营销管理-裂变详情
const Share = () => import('../components/marketing/share/Share.vue') // 营销管理-小程序设置
const MarketingAt = () => import('../components/marketing/PopUpAdvertisement/at.vue') //营销管理-弹窗活动
const NewAt = () => import('../components/marketing/PopUpAdvertisement/newAt.vue') // 营销管理-弹窗广告-新建弹窗
const Scan = () => import('../components/marketing/detail/scan.vue') //营销管理-扫码领券
const newScan = () => import('../components/marketing/detail/newScan.vue') //营销管理-新建扫码领券
const redPack = () => import('../components/distribution/RedPack/redPack.vue') //营销管理-现金红包
const exchange = () => import('../components/marketing/exchange/list.vue') //营销管理-兑换权益
const exchangeDetail = () => import('../components/marketing/exchange/detail.vue') //营销管理-兑换权益

const dis = () => import('../components/distribution/dis/dis.vue') //分销裂变-分销
const disGroup = () => import('../components/distribution/dis/disGroup.vue') //分销裂变-分销组
const disMan = () => import('../components/distribution/dis/disMan.vue') //分销裂变-分销员
const disPage = () => import('../components/distribution/dis/disRecord.vue') //分销裂变-分销详情

const redPackDetail = () => import('../components/distribution/RedPack/redPackDetail.vue') //营销管理-现金红包详情
const Sign = () => import('../components/marketing/Sign/sign.vue')
const Market = () => import('../components/marketing/market/market.vue')
const Market01 = () => import('../components/marketing/market/market01.vue')
// 积分商城
const integralset = () => import('../components/marketing/integralmall/integralset.vue') // 积分商城-积分设置
const integralOrderList = () => import('../components/marketing/integralmall/integralOrderList.vue') // 积分商城-订单列表
const integralget = () => import('../components/marketing/integralmall/integralget.vue') // 积分商城-积分获取记录

//充值卡金
const depositList = () => import('../components/marketing/deposit/depositList.vue') // 充值卡金-充值卡金列表
const newdeposit = () => import('../components/marketing/deposit/newdeposit.vue') // 充值卡金-充值卡金列表
//财务设置
const Asshow = () => import('../components/payment/assetManagement/asshow.vue') // 财务管理-交易管理-支付设置

//抖音管理
const DyManagement = () => import('../components/dyManagement/dyOrderList.vue') // 财务管理-抖音订单
const DyOrderList = () => import('../components/dyManagement/dyOrderList.vue') // 财务管理-抖音订单
const DyOrderEdit = () => import('../components/dyManagement/dyOrderEdit.vue') // 财务管理-抖音订单-抖音订单详情
const DyGoods = () => import('../components/dyManagement/dyGoods.vue') // 财务管理-抖音商品
const DyGoodsEdit = () => import('../components/dyManagement/dyGoodsEdit.vue') // 财务管理-抖音商品

const Payment = () => import('../components/payment/payment/payment.vue') // 财务管理-交易管理-支付设置
const MonthManagement = () => import('../components/payment/monthManagement/monthManagement01.vue') // 财务管理-交易管理-支付设置
const PhoneCredit = () => import('../components/payment/assetManagement/PhoneCredit.vue') // 话费充值
const Express = () => import('../components/payment/assetManagement/express.vue') // 快递发货
const ActivityExpore = () => import('../components/payment/assetManagement/activityExpore.vue') // 财务管理-活动导出
const Aftersales = () => import('../components/payment/assetManagement/aftersales.vue') // 售后订单
// const AssetManagement = () => import('../components/payment/assetManagement/assetManagement.vue') // 财务管理-交易管理-资产管理
const AssetManagement = () => import('../components/payment/assetManagement/as01.vue')
const MeiTuan = () => import('../components/system/meituan.vue') //系统设置-美团授权
const Commission = () => import('../components/payment/commission/commission.vue')

const handle = () => import('../components/system/handle.vue') //系统设置-操作模块
const handleOrder = () => import('../components/system/handle/handleOrder.vue') //系统设置-操作模块-操作订单
const handleCoupon = () => import('../components/system/handle/handleCoupon.vue') //系统设置-操作模块-核销券码
const orderFilter = () => import('../components/payment/assetManagement/orderFilter.vue') //订单过滤

//运营数据监测
const totalRevenueData = () => import('../components/data/dataMonitoring/totalRevenueData.vue') //总运营数据监测
const storeRevenueData = () => import('../components/data/dataMonitoring/storeRevenueData.vue') //门店运营数据监测
const workerRevenueData = () => import('../components/data/dataMonitoring/workerRevenueData.vue') //发型师运营数据监测
const serviceRevenueData = () => import('../components/data/dataMonitoring/serviceRevenueData.vue') //项目运营数据监测

Vue.use(VueRouter)
const routes = [{
    path: '/',
    redirect: '/login'
},
    {
        path: '/blank',
        component: Blank,
    },
    {
        path: '/login',
        component: Login,
        meta: {
            title: '登录'
        }
    }, // meta设置标题title
    {
        path: '/home',
        component: Home,
        redirect: '/index',
        meta: {
            title: '潮剪'
        },
        children: [{
            path: '/index',
            component: Index,
            meta: {
                title: '首页'
            }
        },
            {
                path: '/totalRevenueData',
                component: totalRevenueData,
                meta: {
                    title: '运营数据监测'
                }
            }, {
                path: '/storeRevenueData',
                component: storeRevenueData,
                meta: {
                    title: '运营数据监测'
                }
            }, {
                path: '/workerRevenueData',
                component: workerRevenueData,
                meta: {
                    title: '运营数据监测'
                }
            }, {
                path: '/serviceRevenueData',
                component: serviceRevenueData,
                meta: {
                    title: '运营数据监测'
                }
            },
            {
                path: '/notice',
                component: Notice,
                meta: {
                    title: '通知中心'
                }
            },
            {
                path: '/noticeSetting',
                component: NoticeSetting,
                meta: {
                    title: '通知设置'
                }
            },
            {
                path: '/evaluate',
                component: Evaluate,
                meta: {
                    title: '评价管理'
                }
            },
            {
                path: '/fault',
                component: Fault,
                meta: {
                    title: '问题反馈'
                }
            }, {
                path: '/complaint',
                component: Complaint,
                meta: {
                    title: '消费者投诉-微信'
                }
            },
            {
                path: '/adminList',
                component: AdminList,
                meta: {
                    title: '管理员设置'
                },

            },
            {
                path: '/userData',
                component: UserData,
                meta: {
                    title: '用户数据'
                }
            },
            {
                path: '/workerFileDetail',
                component: WorkerFileDetail,
                meta: {
                    title: '发型师档案详情'
                }
            },
            {
                path: '/hairfiles',
                component: Hairfiles,
                meta: {
                    title: '发型师档案'
                }
            },
            {
                path: '/hair',
                component: Hair,
                meta: {
                    title: '发型师数据'
                }
            },
            {
                path: '/hairfilesdetail',
                component: hairfilesdetail,
                meta: {
                    title: '发型师数据'
                }
            },

            {
                path: '/goodsData',
                component: GoodsData,
                meta: {
                    title: '商品数据'
                }
            },
            {
                path: '/storeData',
                component: StoreData,
                meta: {
                    title: '门店数据'
                }
            },
            {
                path: '/storeFielDetail',
                component: StoreFileDetail,
                meta: {
                    title: '门店档案详情'
                }
            },
            {
                path: '/cost',
                component: Cost,
                meta: {
                    title: '成本核算'
                }
            },
            {
                path: '/workerCostCount',
                component: WorkerCostCount,
                meta: {
                    title: '发型师成本统计'
                }
            },
            {
                path: '/costDetail',
                component: CostDetail,
                meta: {
                    title: '成本详情'
                }
            },
            {
                path: '/dataLive',
                component: DataLive,
                meta: {
                    title: '数据实况'
                }
            },
            {
                path: '/storeList',
                component: StoreList,
                meta: {
                    title: '门店列表'
                }
            },
            {
                path: '/eatTime',
                component: EatTime,
                meta: {
                    title: '就餐时间'
                }
            },
            {
                path: '/storeDetail',
                component: StoreDetail,
                meta: {
                    title: '门店详情页'
                }
            },
            {
                path: '/StoreDetail2',
                component: StoreDetail2,
                meta: {
                    title: '新建门店'
                }
            },
            {
                path: '/attendance',
                component: attendance,
                meta: {
                    title: '考勤中心'
                }
            },
            {
                path: '/join',
                component: Join,
                meta: {
                    title: '加盟管理'
                }
            },
            {
                path: '/join1',
                component: Join1,
                meta: {
                    title: '加盟管理1'
                }
            },
            {
                path: '/material01',
                component: Material01,
                meta: {
                    title: '物资管理'
                }
            },
            {
                path: '/material',
                component: Material,
                meta: {
                    title: '物资管理'
                }
            },
            {
                path: '/storeMaterial',
                component: storeMaterial,
                meta: {
                    title: '门店物资管理'
                }
            },
            {
                path: '/newJoin',
                component: NewJoin,
                meta: {
                    title: '新加盟门商信息'
                }
            },
            {
                path: '/newJoinnext',
                component: NewJoinnext,
                meta: {
                    title: '新加盟门商信息-下一步'
                }
            },
            {
                path: '/typeSetting',
                component: TypeSetting,
                meta: {
                    title: '排班管理'
                }
            },
            {
                path: '/user_data',
                component: User_Data,
                meta: {
                    title: '用戶列表'
                }
            },
            {
                path: '/company_user',
                component: companyUser,
                meta: {
                    title: '企业用户'
                }
            },
            {
                path: '/udata_lists',
                component: Udata_Lists,
                meta: {
                    title: '用户数据列表'
                }
            },
            {
                path: '/operaplan',
                component: Operaplan,
                meta: {
                    title: '用户运营'
                }
            },
            {
                path: '/newopera',
                component: Newopera,
                meta: {
                    title: '用户运营-新建运营计划'
                }
            },
            {
                path: '/setpeoples',
                component: Setpeoples,
                meta: {
                    title: '用户运营-新建人群'
                }
            },
            {
                path: '/addlabel',
                component: Addlabel,
                meta: {
                    title: '用户运营-标签管理-新建标签'
                }
            },
            {
                path: '/volumeset',
                component: Volumeset,
                meta: {
                    title: '营销管理-卷设置'
                }
            },
            {
                path: '/volumeseteffort',
                component: Volumeseteffort,
                meta: {
                    title: '营销管理-新建卷'
                }
            },
            {
                path: '/newvolumeset',
                component: Newvolumeset,
                meta: {
                    title: '营销管理-卷-效果数据'
                }
            },
            {
                path: '/review',
                component: Review,
                meta: {
                    title: '营销管理-评价运营页'
                }
            },
            {
                path: '/meituan/config',
                component: MeituanConfig,
                meta: {
                    title: '营销管理-美团设置'
                }
            },
            {
                path: '/share',
                component: Share,
                meta: {
                    title: '分享有礼'
                }
            },
            {
                path: '/sign',
                component: Sign,
                meta: {
                    title: '签到'
                }
            },
            {
                path: '/market',
                component: Market,
                meta: {
                    title: '潮剪集市'
                }
            },
            {
                path: '/market01',
                component: Market01,
                meta: {
                    title: '潮剪集市详情'
                }
            },
            {
                path: '/marketingShare',
                component: marketingShare,
                meta: {
                    title: '裂变活动'
                }
            },
            {
                path: '/DmarketingShare',
                component: DmarketingShare,
                meta: {
                    title: '裂变活动详情'
                }
            },

            {
                path: '/product_user',
                component: product_user,
                meta: {
                    title: '产品管理-会员管理'
                }
            },
            {
                path: '/timeCard',
                component: timeCard,
                meta: {
                    title: '产品管理-次卡管理'
                }
            },
            {
                path: '/timeCardDetail',
                component: timeCardDetail,
                meta: {
                    title: '产品管理-次卡详情'
                }
            },
            {
                path: '/product_set',
                component: product_set,
                meta: {
                    title: '会员管理-会员设置'
                }
            },
            {
                path: '/product_hair',
                component: product_hair,
                meta: {
                    title: '产品管理-剪发服务'
                }
            },
            {
                path: '/add_hair',
                component: add_hair,
                meta: {
                    title: '产品管理-新建'
                }
            },
            {
                path: '/product_hair3',
                component: product_hair3,
                meta: {
                    title: '新建计划'
                }
            },
            {
                path: '/productGroup',
                component: productGroup,
                meta: {
                    title: '套餐列表'
                }
            },
            {
                path: '/productGroupDetail',
                component: productGroupDetail,
                meta: {
                    title: '套餐详情'
                }
            },
            {
                path: '/addroles',
                component: addroles,
                meta: {
                    title: '系统设置-添加员工'
                }
            },
            {
                path: '/journal',
                component: journal,
                meta: {
                    title: '系统设置-操作日志'
                }
            },
            {
                path: '/jurisdiction',
                component: jurisdiction,
                meta: {
                    title: '系统设置-权限设置'
                }
            },
            {
                path: '/employedetails',
                component: employedetails,
                meta: {
                    title: '系统设置-员工详情'
                }
            },
            {
                path: '/creatingroles',
                component: creatingroles,
                meta: {
                    title: '系统设置-创建角色'
                }
            },
            {
                path: '/hairdetail',
                component: hairdetail,
                meta: {
                    title: '系统设置-创建角色'
                }
            },
            {
                path: '/achievement',
                component: achievement,
                meta: {
                    title: '系统设置-创建角色'
                }
            },
            {
                path: '/hairlist',
                component: hairlist,
                meta: {
                    title: '系统设置-创建角色'
                }
            },
            {
                path: '/meituan',
                component: MeiTuan,
                meta: {
                    title: '系统设置-美团授权'
                }
            },
            //添加
            {
                path: '/Advertisement',
                component: Advertisement,
                meta: {
                    title: '营销管理-弹出广告'
                }
            },
            {
                path: '/marketingAd',
                component: MarketingAd,
                meta: {
                    title: '营销管理-弹出广告'
                }
            },
            {
                path: '/newAD',
                component: NewAD,
                meta: {
                    title: '营销管理-弹出广告-新建弹窗'
                }
            },
            {
                path: '/exchangecode',
                component: ExchangeCode,
                meta: {
                    title: '营销管理-兑换码'
                }
            },
            {
                path: '/exchange',
                component: exchange,
                meta: {
                    title: '营销管理-兑换权益'
                }
            },
            {
                path: '/exchangeDetail',
                component: exchangeDetail,
                meta: {
                    title: '营销管理-兑换权益详情'
                }
            },
            {
                path: '/newExchangecode',
                component: NewExchangeCode,
                meta: {
                    title: '营销管理-兑换码-新建兑换码'
                }
            },
            {
                path: '/exhistory',
                component: Exhistory,
                meta: {
                    title: '营销管理-兑换码-使用记录'
                }
            },
            {
                path: '/helpActive',
                component: HelpActive,
                meta: {
                    title: '营销管理-助力活动'
                }
            },
            {
                path: '/newHelpActive',
                component: NewHelpActive,
                meta: {
                    title: '营销管理-助力活动-新建助力'
                }
            },
            {
                path: '/helpDetails',
                component: HelpDetails,
                meta: {
                    title: '营销管理-助力活动-助力详情'
                }
            },
            {
                path: '/helpDetails',
                component: HelpDetails,
                meta: {
                    title: '营销管理-助力活动-助力详情'
                }
            },
            {
                path: '/coupons',
                component: Coupons,
                meta: {
                    title: '营销管理-券包设置'
                }
            },
            {
                path: '/newCoupons',
                component: NewCoupons,
                meta: {
                    title: '营销管理-券包设置-新建优惠券包'
                }
            },
            {
                path: '/poster',
                component: Poster,
                meta: {
                    title: '营销管理-裂变海报'
                }
            },
            {
                path: '/newPoster',
                component: NewPoster,
                meta: {
                    title: '营销管理-裂变海报-新建裂变海报'
                }
            },
            {
                path: '/makeUpAGroup',
                component: MakeUpAGroup,
                meta: {
                    title: '营销管理-拼团管理'
                }
            },
            {
                path: '/newMakeUpAGroup',
                component: NewMakeUpAGroup,
                meta: {
                    title: '营销管理-拼团管理-创建拼团'
                }
            },
            {
                path: '/appletSettings',
                component: AppletSettings,
                meta: {
                    title: '营销管理-小程序设置'
                }
            },
            {
                path: '/memberDetailSetting',
                component: memberDetailSetting,
                meta: {
                    title: '营销管理-会员权益设置'
                }
            },
            //积分商城
            {
                path: '/integralset',
                component: integralset,
                meta: {
                    title: '积分商城-积分设置'
                }
            },
            {
                path: '/integralOrderList',
                component: integralOrderList,
                meta: {
                    title: '积分商城-订单列表'
                }
            },
            {
                path: '/integralget',
                component: integralget,
                meta: {
                    title: '积分商城-积分获取记录'
                }
            },
            //充值卡金
            {
                path: '/depositList',
                component: depositList,
                meta: {
                    title: '充值卡金-充值卡金列表'
                }
            },
            {
                path: '/newdeposit',
                component: newdeposit,
                meta: {
                    title: '新建充值卡金'
                }
            },
            // {
            // 	path: '/integralSetting',
            // 	component: IntegralSetting,
            // 	meta: {
            // 		title: '积分商城-积分设置'
            // 	}
            // },
            // {
            // 	path: '/newPoints',
            // 	component: NewPoints,
            // 	meta: {
            // 		title: '积分商城-积分设置-新建积分'
            // 	}
            // },
            // {
            // 	path: '/productRelease',
            // 	component: ProductRelease,
            // 	meta: {
            // 		title: '积分商城-商品发布'
            // 	}
            // },
            // {
            // 	path: '/newGoods',
            // 	component: NewGoods,
            // 	meta: {
            // 		title: '积分商城-商品发布-新建商品'
            // 	}
            // },

            //抖音管理
            {
                path: '/dyManagement',
                component: DyManagement,
                meta: {
                    title: '抖音管理'
                }
            },
            {
                path: '/dyGoods',
                component: DyGoods,
                meta: {
                    title: '抖音商品管理'
                }
            },
            {
                path: '/dyGoodsEdit',
                component: DyGoodsEdit,
                meta: {
                    title: '抖音商品详情'
                }
            },


            //财务设置
            {
                path: '/payment',
                component: Payment,
                meta: {
                    title: '交易管理-支付设置'
                }
            },
            {
                path: '/assetManagement',
                component: AssetManagement,
                meta: {
                    title: '交易管理-资产管理'
                }
            },
            {
                path: '/dyManagement',
                component: DyManagement,
                meta: {
                    title: '抖音管理'
                }
            },
            {
                path: '/monthManagement',
                component: MonthManagement,
                meta: {
                    title: '交易管理-月度统计'
                }
            },
            {
                path: '/asshow',
                component: Asshow,
                meta: {
                    title: '交易管理-订单详情'
                }
            },
            {
                path: '/commission',
                component: Commission,
                meta: {
                    title: '业绩提成'
                }
            },
            {
                path: '/marketingAt',
                component: MarketingAt,
                meta: {
                    title: '营销管理-弹出活动'
                }
            },
            {
                path: '/scan',
                component: Scan,
                meta: {
                    title: '营销管理-扫码领券'
                }
            },
            {
                path: '/newScan',
                component: newScan,
                meta: {
                    title: '营销管理-新建扫码领券'
                }
            },
            {
                path: '/newAt',
                component: NewAt,
                meta: {
                    title: '营销管理-弹出活动-新建活动'
                }
            },
            {
                path: '/covidUpload',
                component: covid,
                meta: {
                    title: '发型师管理-疫情申报'
                }
            },
            {
                path: '/changeStore',
                component: changeStore,
                meta: {
                    title: '发型师管理-定时调店'
                }
            },
            {
                path: '/workerDiscount',
                component: workerDiscount,
                meta: {
                    title: '发型师管理-熟客抵扣'
                }
            },
            {
                path: '/redPack',
                component: redPack,
                meta: {
                    title: '营销管理-现金红包'
                }
            },
            {
                path: '/redPackDetail',
                component: redPackDetail,
                meta: {
                    title: '营销管理-现金红包详情'
                }
            },
            {
                path: '/ActivityExpore',
                component: ActivityExpore,
                meta: {
                    title: '财务管理-活动导出'
                }
            },
            {
                path: '/Aftersales',
                component: Aftersales,
                meta: {
                    title: '订单管理-售后管理'
                }
            },
            {
                path: '/DyOrderList',
                component: DyOrderList,
                meta: {
                    title: '财务管理-抖音订单'
                }
            },
            {
                path: '/DyOrderEdit',
                component: DyOrderEdit,
                meta: {
                    title: '交易管理-订单详情'
                }
            },

            {
                path: '/dis',
                component: dis,
                meta: {
                    title: '分销管理'
                }
            },
            {
                path: '/handle',
                component: handle,
                meta: {
                    title: '操作模块'
                }
            },
            {
                path: '/handleOrder',
                component: handleOrder,
                meta: {
                    title: '操作模块-操作订单'
                }
            },
            {
                path: '/ccard',
                component: productCCard,
                meta: {
                    title: '卡金会员'
                }
            },
            {
                path: '/addCcard',
                component: addCCard,
                meta: {
                    title: '新增卡金'
                }
            },
            {
                path: '/uvip',
                component: productUVip,
                meta: {
                    title: 'VIP会员'
                }
            },
            {
                path: '/addUvip',
                component: addUVip,
                meta: {
                    title: 'VIP会员'
                }
            },
        ]
    },
]

const router = new VueRouter({
    routes,
    mode: 'hash', //隐藏 #路由
    //页面跳转显示在顶部
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

// 路由守卫
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    document.title = to.meta.title // 让标题设置为routes中meta的ttitle
    if (to.path === '/login') return next()
    const tokenStr = window.localStorage.getItem('Authorization')
    if (!tokenStr) {
        return next('/login')
    }
    next()
})
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    // next()

})


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
